<div class="back-button" (click)="backClick.emit()">
  <svg width="16" height="16" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8L18 6L9 15L18 24L20 22L13 15L20 8Z"/>
  </svg>
  <span>Back</span>
</div>
